const toggleDisplay = (triggerClass, targetClass) => {
  // Select all elements with the trigger class
  const triggers = document.querySelectorAll(triggerClass);

  // Add click event listener to each trigger
  triggers.forEach((trigger) => {
    trigger.addEventListener('click', function (event) {
      // Select all elements with the target class
      const targets = document.querySelectorAll(targetClass);

      // Toggle the display of each target
      targets.forEach((target) => {
        if (window.getComputedStyle(target).display === 'none') {
          target.style.display = 'block';
        } else {
          target.style.display = 'none';
        }
      });
    });
  });
};

// Toggle filter button on mobile screens to defer conflict with menu drawer
document.addEventListener('DOMContentLoaded', function () {
  toggleDisplay('.menu-drawer-container', '.facets-wrapper');
});
